import {Box, Button, Modal, Tooltip} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useEffect,
  useState,
} from 'react';

import AlarmShortcodeForm from './AlarmShortcodeForm';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  type: 'warn' | 'evacuate';
  component?: T;
  disabled?: boolean;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  forceOpen?: boolean;
  preSelected?: number[];
  onSubmitted?: () => void;
  onClose?: () => void;
  messageId?: number;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '500px',
  bgcolor: 'background.paper',
  border: '1px solid #9b9b9b',
  boxShadow: 24,
  // p: 3,
  overflow: 'auto',
  maxHeight: '100%',
};

const AlarmWarningAllShortCodeButton = <T extends ComponentType>({
  type,
  component,
  disabled,
  componentProps,
  children,
  forceOpen,
  preSelected,
  onSubmitted,
  onClose,
  messageId,
}: Props<T>) => {
  const Component = component ?? Button;

  const [isOpened, setIsOpened] = useState(false);
  useEffect(() => {
    if (forceOpen === true) {
      setIsOpened(true);
    }
  }, [forceOpen]);
  return (
    <>
      <Tooltip title={type === 'warn' ? 'Warn All' : 'Evacuate All'}>
        <Component
          {...componentProps}
          disabled={disabled}
          onClick={() => setIsOpened(true)}
        >
          {children}
        </Component>
      </Tooltip>

      {isOpened ? (
        <Modal
          open={isOpened}
          onClose={() => {
            onClose?.();
            setIsOpened(false);
          }}
        >
          <Box sx={style}>
            <AlarmShortcodeForm
              type={type}
              onSubmitted={onSubmitted}
              preSelected={preSelected}
              onClose={() => {
                onClose?.();
                setIsOpened(false);
              }}
              messageId={messageId}
            />
          </Box>
        </Modal>
      ) : null}
    </>
  );
};

export default AlarmWarningAllShortCodeButton;
